module.exports = __webpack_public_path__ + "img/xa.6369a0ba.png";